import { HandoverLog } from '../../../models/handover-log.model';
import { HighAlert } from '../../../models/high-alert.model';
import { ShiftLog } from '../../../models/shift-log.model';

export type Recurrence = 'none' | 'daily' | 'weekly' | 'monthly';

export enum TaskDialogResultAction {
  CANCEL = 'cancel',
  CREATE = 'create',
  UPDATE = 'update',
}

export enum TaskDialogMode {
  VIEW = 'view',
  EDIT = 'edit',
  CREATE = 'create',
}

export enum FormStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
}

export type TaskDialogResult<TLog, TValue> =
  | { action: TaskDialogResultAction.CANCEL }
  | { action: TaskDialogResultAction.CREATE; resultTaskFormValue: TValue }
  | { action: TaskDialogResultAction.UPDATE; inputLog: TLog; resultTaskFormValue: TValue };

export interface HandoverTaskFormValue {
  programId: string;
  notes: string;
  dueDate: string; // "YYYY-MM-DDTHH:mm"
  timezone: string;
  activity: string;
}

export interface HighAlertTaskFormValue {
  programId: string;
  programIds: string[];
  notes: string;
  startDate: string; // "YYYY-MM-DDTHH:mm"
  endDate: string; // "YYYY-MM-DDTHH:mm"
  timezone: string;
  window: string;
}

export interface ShiftLogTaskFormValue {
  programId: string;
  notes: string;
  dueDate: string; // "YYYY-MM-DDTHH:mm"
  activity: string;
}

export interface TaskDialogData {
  title: string;

  /** create | edit | view (view = read-only) */
  mode: TaskDialogMode;

  defaults?: Partial<HandoverTaskFormValue | ShiftLogTaskFormValue | HighAlertTaskFormValue>;

  log?: HandoverLog | ShiftLog | HighAlert;
}
